/**
 * Titel van een taak zoals hij in de agenda staat.
 *
 * Een projectafspraak leeft in de omgeving van de beheerder, niet in die van
 * het project. Zonder de projectnaam erbij zegt "Cijfers aanleveren" in een
 * agenda met tientallen projecten niets. De naam staat op de taak zelf
 * (gedenormaliseerd bij het opslaan), zodat de agenda er geen extra
 * database-vraag voor hoeft te stellen.
 *
 * Een huisbezoek heet standaard letterlijk "Huisbezoek", dus een dag met vijf
 * bezoeken toonde vijf keer hetzelfde woord. Het adres komt erachter: uit
 * `AdressLabel` (sinds september 2026 bij het aanmaken weggeschreven), en voor
 * oudere bezoeken uit `Description` — daar zet elke aanmaakroute het adres in
 * (`getAdressDescription`), als "Straat nummer, Woonplaats". De woonplaats
 * blijft weg, het blok is smal. De naam van de bewoner komt bewust NIET in
 * de titel: die staat als aparte regel in het blok (`AdressName`), zodat hij
 * niet in elke titel en elk lijstje meereist.
 *
 * AI-CONTEXT: See docs/patterns.md#data-denormalise-label-onto-response
 * AI-CONTEXT: See docs/features/agenda-persoonskleur-en-huisbezoek-titel.md
 *
 * @param {{Type?: string, Title?: string, ProjectName?: string, AdressLabel?: string, Description?: string}|null|undefined} task
 * @returns {string}
 */
const taskEventTitle = (task) => {
    const title = task?.Title || ''
    const project = task?.ProjectName || ''

    if (project) return title ? `${project} — ${title}` : project

    if (task?.Type === 'addressVisit') {
        const adres = visitAddress(task)
        if (adres) return title ? `${title} — ${adres}` : adres
    }

    return title
}

/**
 * Het adres van een huisbezoek: het vaste label, anders de eerste regel van
 * de beschrijving zonder het deel na de komma (de woonplaats).
 *
 * @param {{AdressLabel?: string, Description?: string}} task
 * @returns {string}
 */
const visitAddress = (task) => {
    const label = (task.AdressLabel || '').trim()
    if (label) return label

    const firstLine = (task.Description || '').split('\n')[0]
    return firstLine.split(',')[0].trim()
}

export default taskEventTitle
